import { useState } from "react";
import NavSidebar from "../Sidebar/NavSidebar";
import BtnPrimaryM from "../Buttons/BtnPrimaryM";
import { useLanguage } from "../../context/LanguageContext";
import PropTypes from "prop-types";

const StartMessage = ({ title, message }) => {
  const [sidebarToggled, setSidebarToggled] = useState(false);
  const { copy } = useLanguage();

  return (
    <>
      <div className="flex items-center justify-center min-h-[calc(100vh-200px)] w-full">
        <div className="flex flex-col items-center justify-center text-center gap-4">
          <h1 className="text-3xl font-semibold">{title}</h1>
          <p className="text-base mb-4">{message}</p>
          <BtnPrimaryM
            buttonCTA={copy.start_message.button_get_started}
            onClickLink={() => setSidebarToggled(true)}
            type="button"
          />
        </div>
      </div>

      {sidebarToggled && (
        <NavSidebar setSidebarToggled={() => setSidebarToggled(false)} />
      )}
    </>
  );
};

StartMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default StartMessage;
